export default __webpack_public_path__ + "static/media/icon-plus-horaire.0579c1c0.svg";